import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";
import EmptyState from "@/components/feature/EmptyState";
import { specialList } from "@/utils/content";

const tags = ["全部", "深度解读", "影史", "技术", "情感", "叙事", "幕后"];

export default function SpecialPage() {
  const [tag, setTag] = useState("全部");

  const items = useMemo(() => {
    if (tag === "全部") return specialList;
    return specialList.filter(
      (item) => item.tags.includes(tag) || item.genres.includes(tag)
    );
  }, [tag]);

  return (
    <div className="bg-background-50">
      <div className="mx-auto max-w-page px-4 md:px-6 py-8 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "影视专题" }]} />

        <div className="mt-5 md:mt-6">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            影视评论与解说专题
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-3xl leading-7">
            影视工厂专题频道聚焦影视评论与深度解读，从影史脉络到幕后技术，用更有深度的视角，
            带你重新认识那些值得反复品味的作品。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {tags.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setTag(item)}
              className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                item === tag
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        {items.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} 影视工厂专题`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 px-2 py-0.5 rounded text-xs bg-accent-500 text-foreground-950">
                    {item.genres[0]}
                  </span>
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-heading text-xl text-foreground-950 tracking-wide line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{item.summary}</p>
                  <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-article-line" />
                      {item.articles?.length ?? 0} 篇相关解读
                    </span>
                    <span className="flex items-center gap-1 group-hover:text-primary-600 transition-colors">
                      查看专题
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <EmptyState
            title="暂无相关专题"
            description="换个标签看看，或者返回首页探索更多精彩内容。"
            actionLabel="查看全部专题"
            onAction={() => setTag("全部")}
          />
        )}
      </div>
    </div>
  );
}